import { QRTrackService } from "../services/QRTrackService";
import { QRTrackConstants } from "../constants/QRTrackConstants";
import { alertActions } from ".";

export const QRTrackActions = {
  toggle,
  toggle2,
  GetScanInfo,
  GetJourney,
};

// 🚀 Scan Info Action
function GetScanInfo(data) {
  return (dispatch) => {
    dispatch(request());

    QRTrackService.GetScanInfo(data).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: QRTrackConstants.TRACK_SCAN_INFO_REQUEST };
  }

  function success(datas) {
    return {
      type: QRTrackConstants.TRACK_SCAN_INFO_SUCCESS,
      datas, // This gets stored in `scanInfo.TIDproducts` via reducer
    };
  }

  function failure(error) {
    return { type: QRTrackConstants.TRACK_SCAN_INFO_FAILURE, error };
  }
}

// 🔁 Toggle Action 1
function toggle(data) {
  return (dispatch) => {
    dispatch(request());

    QRTrackService.GetScanInfo(data).then(
      (response) => {
        dispatch(loadingData(false));
        const resp = response.ResponseData;

        let qr = [];
        let seen = new Set();

        resp.forEach((element) => {
          if (!seen.has(element.Id)) {
            seen.add(element.Id);
            qr.push(element);
          }
        });

        dispatch(success(qr));
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: QRTrackConstants.TRACK_TOGGLE_REQUEST };
  }

  function success(datas) {
    return { type: QRTrackConstants.TRACK_TOGGLE_SUCCESS, datas };
  }

  function failure(error) {
    return { type: QRTrackConstants.TRACK_TOGGLE_FAILURE, error };
  }
}

// 🔁 Toggle Action 2
function toggle2(data) {
  return (dispatch) => {
    dispatch(request());

    QRTrackService.GetScanInfo(data).then(
      (response) => {
        dispatch(loadingData(false));

        const resp = response.ResponseData;
        let qr = [];
        let seen = new Set();

        resp.forEach((element) => {
          if (!seen.has(element.Id)) {
            seen.add(element.Id);
            qr.push(element);
          }
        });

        dispatch(success(qr)); // Return filtered data
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: QRTrackConstants.TRACK_TOGGLE_2_REQUEST };
  }

  function success(datas) {
    return { type: QRTrackConstants.TRACK_TOGGLE_2_SUCCESS, datas };
  }

  function failure(error) {
    return { type: QRTrackConstants.TRACK_TOGGLE_2_FAILURE, error };
  }
}

// 📍 Journey Action
function GetJourney(data) {
  return (dispatch) => {
    dispatch(request());

    QRTrackService.GetJourney(data).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: QRTrackConstants.TRACK_JOURNEY_INFO_REQUEST };
  }

  function success(datas) {
    return {
      type: QRTrackConstants.TRACK_JOURNEY_INFO_SUCCESS,
      datas,
    };
  }

  function failure(error) {
    return {
      type: QRTrackConstants.TRACK_JOURNEY_INFO_FAILURE,
      error,
    };
  }
}

// ⏳ Optional generic loading handler
function loadingData(isbool) {
  return {
    type: QRTrackConstants.LOADING_REQUEST,
    isbool,
  };
}
